import { IgrSeries } from "./igr-series";
/**
 * Represents event arguments for chart's SeriesAdded and SeriesRemoved events
*/
var IgrChartSeriesEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrChartSeriesEventArgs() {
    }
    Object.defineProperty(IgrChartSeriesEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrChartSeriesEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrChartSeriesEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    };
    Object.defineProperty(IgrChartSeriesEventArgs.prototype, "series", {
        /**
         * Gets the series.
        */
        get: function () {
            var r = this.i.series;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = IgrSeries._createFromInternal(r);
                if (e) {
                    e._implementation = r;
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        set: function (v) {
            v == null ? this.i.series = null : this.i.series = v.i;
        },
        enumerable: false,
        configurable: true
    });
    return IgrChartSeriesEventArgs;
}());
export { IgrChartSeriesEventArgs };
